// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-562c32c6] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.option[data-v-562c32c6] {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--height);
  cursor: inherit;
}
.option__avatar[data-v-562c32c6] {
  margin-right: var(--margin);
}
.option__details[data-v-562c32c6] {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}
.option__lineone[data-v-562c32c6] {
  color: var(--color-main-text);
}
.option__linetwo[data-v-562c32c6] {
  color: var(--color-text-maxcontrast);
}
.option__lineone[data-v-562c32c6],
.option__linetwo[data-v-562c32c6] {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.1em;
}
.option__lineone strong[data-v-562c32c6],
.option__linetwo strong[data-v-562c32c6] {
  font-weight: 700;
}
.option__icon[data-v-562c32c6] {
  width: 44px;
  height: 44px;
  color: var(--color-text-maxcontrast);
}
.option__icon.icon[data-v-562c32c6] {
  flex: 0 0 44px;
  opacity: .7;
  background-position: center;
  background-size: 16px;
}
.option__details[data-v-562c32c6],
.option__lineone[data-v-562c32c6],
.option__linetwo[data-v-562c32c6],
.option__icon[data-v-562c32c6] {
  cursor: inherit;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcListItemIcon-9Dazpmpd.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;;;;EAIE,eAAe;AACjB","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-562c32c6] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.option[data-v-562c32c6] {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: var(--height);\n  cursor: inherit;\n}\n.option__avatar[data-v-562c32c6] {\n  margin-right: var(--margin);\n}\n.option__details[data-v-562c32c6] {\n  display: flex;\n  flex: 1 1;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n.option__lineone[data-v-562c32c6] {\n  color: var(--color-main-text);\n}\n.option__linetwo[data-v-562c32c6] {\n  color: var(--color-text-maxcontrast);\n}\n.option__lineone[data-v-562c32c6],\n.option__linetwo[data-v-562c32c6] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  line-height: 1.1em;\n}\n.option__lineone strong[data-v-562c32c6],\n.option__linetwo strong[data-v-562c32c6] {\n  font-weight: 700;\n}\n.option__icon[data-v-562c32c6] {\n  width: 44px;\n  height: 44px;\n  color: var(--color-text-maxcontrast);\n}\n.option__icon.icon[data-v-562c32c6] {\n  flex: 0 0 44px;\n  opacity: .7;\n  background-position: center;\n  background-size: 16px;\n}\n.option__details[data-v-562c32c6],\n.option__lineone[data-v-562c32c6],\n.option__linetwo[data-v-562c32c6],\n.option__icon[data-v-562c32c6] {\n  cursor: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
